<template>
  <Skeleton
      width="320px"
      height="100%"
      v-if="appState.initial"
  ></Skeleton>
  <FloatLabel variant="on" class="chat-widget__w-100" v-else>
    <Select
        v-model="userInput.selectedPreset"
        :options="reference.presetGroups"
        optionLabel="title"
        optionGroupLabel="title"
        optionGroupChildren="presets"
        scroll-height="21rem"
        placeholder="Выберите шаблон задачи"
        @change="userInput.changePresetHandle"
        class="chat-widget__w-100"
        append-to="self"
        filter
        inputId="on_label"
    >
      <template #optiongroup="slotProps">
        <div>
          <div># {{ slotProps.option.title }}</div>
        </div>
      </template>
      <template #value="slotProps">
        <div v-if="slotProps.value">
          <div>{{ slotProps.value.title }}</div>
        </div>
        <span v-else>
          {{ slotProps.placeholder }}
        </span>
      </template>
      <template #option="slotProps">
        <div class="chat-widget__preset-select--option">
          {{ slotProps.option.title }}
        </div>
      </template>
    </Select>
    <label for="on_label">{{ userInput.selectedPreset ? 'Шаблон задачи' : '' }}</label>
  </FloatLabel>
</template>
<script setup>
import Select from 'primevue/select';
import Skeleton from 'primevue/skeleton';
import FloatLabel from 'primevue/floatlabel';
import {useReferenceStore} from '@/modules/chat/stores/referenceStore';
import {useInputStore} from '@/modules/chat/stores/userInputStore';
import {useAppStateStore} from '@/modules/chat/stores/appStore';

const reference = useReferenceStore();
const userInput = useInputStore();
const appState = useAppStateStore();
</script>